export default __webpack_public_path__ + "static/media/Fixed-Monthly-Withdrawal.70cae707.png";